export default {
  form: {
    companyName: 'Nazwa marki',
    companyNameLabel: 'Podaj nazwe marki',
    firstname: 'Imię',
    firstname_label: 'Podaj swoje imię...',
    lastname_label: 'Podaj swoje nazwisko...',
    lastname: 'Nazwisko',
    username: 'Nazwa użytkownika',
    email: 'E-mail',
    email_label: 'Podaj e-mail',
    password: 'Hasło',
    password_label: 'Podaj hasło',
    signIn: 'Zaloguj się',
    signUp: 'Zarejestruj się',
    role: 'Rola',
    client: 'Sklep',
    country_label:"Wybierz z listy",
    country:'Kraj',
    address1_client:'Adres sklepu',
    clientDescription: 'Chcę kupować upcyklingowe produkty.',
    designer: 'Marka',
    designerDescription: 'Chcę sprzedawać moje upcyklingowe produkty i stworzyć profil marki.',
    corporate: 'Klient korporacyjny',
    corporateDescription:'Chcę realizować projekty cyrkularne i udostępniać strumienie odpadów mojej firmy.',
    company: 'Nazwa marki',
    main_category: 'Główna kategoria marki',
    detalis_accounts: 'SZCZEGÓŁY DOTYCZĄCE MARKI',
    instagram_link: 'Link do instagrama',
    description_mark:'Czy mógłbys powiedzieć nam więcej o swojej marce i produktach ?',
    description_mark_solo: 'Napisz nam o swojej marce pare słów',
    number_detailist: 'Liczba partnerów detalicznych',
    companyNameShop:'Nazwa sklepu',
    companyNameShopLabel: 'Podaj nazwę sklepu',
    address1: 'Adres marki',
    address1_label: 'Podaj nazwe ulicy oraz numer budynku',
    zipcode: 'Kod pocztowy',
    zipcode_label: 'Podaj kod pocztowy',
    state: 'Stan/Województwo',
    phone_number: 'Telefon',
    phone_number_label:'Podaj nr telefon w formacie +48 000 000 000',
    url: 'Adres strony internetowej',
    city: 'Miasto',
    description: 'Opis marki',
    privacyPolicyLabel: 'Polityka prywatności',
    termsAndConditionsLabel: 'Warunki współpracy',
    informationsAboutShop: 'INFORMACJE DOTYCZĄCE SKLEPU',
    informationsAboutMarket: 'INFORMACJE DOTYCZĄCE MARKI',
    personalData: 'DANE OSOBOWE',
    loginData: 'DANE DO LOGOWANIA',
    termsAndConditionsDescription: 'Niniejszym potwierdzam, że zapoznałem się, zrozumiałem i zgadzam się na {terms} oraz {privacy} platformy Dekoeko.',
    receiveLatestNewsLabel: 'Otrzymuj najnowsze wiadomości',
    receiveLatestNewsDescription: 'Wyrażam zgodę na otrzymywanie najnowszych wiadomości o trendach, pomysłach na unikalne produkty oraz promocje specjalne od Dekoeko w formie wiadomości e-mail.',
    cannotCreateAccount: 'Nie można utworzyć konta. Jeżeli wypełniłeś wszystkie pola poprawnie i problem się powtarza, napisz do nas na designers@dekoeko.com',
    freeAccountInfo: 'Zakładając teraz konto na platformie Deko Eko zyskujesz 40 dniowy, darmowy dostęp do wszystkich funkcjonalności konta dla biznesu. 10 dni przed końcem darmowego okresu przypomnimy ci o zbliżającym się terminie - będziesz miał czas podjąć decyzję czy utrzymujesz swoje konto (w wersji płatnej) czy zawieszasz je (nie ponosisz wtedy żadnych opłat).'
},
actions: {
  successSignIn: 'Zalogowano pomyślnie',
    successSignUp: 'Zarejestrowano pomyślnie',
  },
  stepper: {
    firstStep: {
      title: 'Chcę dołączyć do Deko Eko jako: ',
      subtitle: 'Rola zdefiniuje Twój dostęp w platformie',
    },
    secondStep: {
      title: 'Podstawowe informacje',
    },
    thirdStep: {
      title: 'Informacje o twojej firmie',
    },
    next: 'Dalej',
    back: 'Wróć',
    sendApplication: 'Wyślij zgłoszenie',
    signUp: 'Zarejestruj się'
  },
};
